import { useCallback, useEffect, useRef, useState } from 'react';
import { nativeRequest } from './nativeBridge';
import { orderManagedProducts } from '../../Component/tool/managedProductOrder';

export type StudioProduct = { seq: number; live_seq: number; name: string; price: number; current_cnt: number;
  display_order?: number | null;
  product_status: string;
  exposure_active?: boolean | null; exposure_price_mode?: 'visible' | 'seller' | 'hidden'; thumbnail_img?: string; product_img?: string;
  product_description?: string; option_check?: string };
export type StudioWorkspace = { products: StudioProduct[]; totalSales: number | null; liveNotice: string | null; regularNotice?: string | null;
  detail: { productSeq: number; description: string; options: { seq: number; option1: string; option2: string; current_cnt: number }[] | null } | null };

export function useBroadcastWorkspace(seq: number, enabled: boolean, refreshVersion: number) {
  const [data, setData] = useState<StudioWorkspace | null>(null);
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);
  const [refresh, setRefresh] = useState(0);
  const pending = useRef(false);
  const currentSeq = useRef(seq); currentSeq.current = seq;
  useEffect(() => { setData(null); setError(''); }, [seq, enabled]);
  useEffect(() => {
    if (!enabled) return;
    let active = true, loading = false;
    const load = async () => {
      if (loading) return;
      loading = true;
      try {
        const result = await nativeRequest<StudioWorkspace>('studio-data');
        if (!Array.isArray(result?.products)) throw new Error('상품 목록을 불러오지 못했습니다.');
        if (active) { setData({ ...result, products: orderManagedProducts(result.products) }); setError(''); }
      } catch (failure) { if (active) setError((failure as Error).message); }
      finally { loading = false; }
    };
    void load();
    const focus = () => { if (!document.hidden) void load(); };
    window.addEventListener('focus', focus);
    const timer = window.setInterval(focus, 5000);
    return () => { active = false; window.clearInterval(timer); window.removeEventListener('focus', focus); };
  }, [seq, enabled, refreshVersion, refresh]);
  const changeExposure = useCallback(async (productSeq: number, mode: 'off' | 'visible' | 'seller') => {
    if (!enabled || pending.current) return;
    const requestedSeq = seq;
    pending.current = true; setSaving(true); setError('');
    try {
      await nativeRequest('product-exposure', { productSeq, mode });
      if (currentSeq.current === requestedSeq) setRefresh(value => value + 1);
    } catch (failure) { if (currentSeq.current === requestedSeq) setError((failure as Error).message); }
    finally { pending.current = false; if (currentSeq.current === requestedSeq) setSaving(false); }
  }, [seq, enabled]);
  return { data, error, saving, changeExposure, reload: () => setRefresh(value => value + 1) };
}
